//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    headings: {
      type: Array,
      required: true,
    },
    activeHeading: {
      type: String,
      default: null,
    },
  },
  computed: {
    progressPercentage() {
      const total = this.headings.length
      if (total === 0) return 0
      const index = this.headings.findIndex((h) => h === this.activeHeading)
      if (index === -1) {
        return 0
      }
      return Math.round(((index + 1) / total) * 100)
    },
  },
  methods: {
    handleHeadingClick(headingText) {
      this.$emit('heading-selected', headingText)
    },
  },
}
